// extracted by mini-css-extract-plugin
export default {"login":"Login_login__qB+Ba","form":"Login_form__MFfho","input":"Login_input__O8kvB","button":"Login_button__3LeqT","error":"Login_error__kWjIk"};